<template>
  <span v-if="type === 'array' && value">
    <v-chip v-for="(v, i) in value" :key="i" small outlined color="primary">
      {{ v }}
    </v-chip>
  </span>
  <span
    v-else-if="type === 'boolean'"
    :class="`${value ? 'success' : 'grey'}--text`"
  >
    {{ value ? "Sí" : "No" }}
  </span>
  <span v-else>{{ value }}</span>
</template>
<script>
export default {
  name: "TableCustomField",
  props: {
    type: String, //boolean, string, number, array
    value: [String, Number, Boolean, Array]
  }
};
</script>
